var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabelingPallet = function SvgLabelingPallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 58,
    viewBox: "0 0 54 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#CBAB87",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.913 41.205L26.38 31.173"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M26.803 53.075v2.518M37.722 48.61v2.762M13.667 46.984v2.955"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M51.545 41.665v4.161"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.78 41.564v3.987M2.116 41.61L26.933 52M26.729 31.219l24.816 10.39M2.116 45.91L26.933 56.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.688 20.894c5.237-2.64 9.099-3.96 11.587-3.96 2.489 0 6.141 1.32 10.958 3.96l.63 14.21c-5.345 3.12-9.331 4.679-11.959 4.679-2.627 0-6.366-1.56-11.216-4.679v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AAB",
    stroke: "#007AAB",
    d: "M37.127 26.966v7.618L26.72 38.852V25.903l10.408-4.268v5.331zM25.563 38.852l-10.41-4.268V21.635l10.41 4.268v12.949zm.578-22.196l10.007 4.103-10.007 4.088-9.975-4.088 9.975-4.103zm12.143 9.306V20.76a.59.59 0 0 0-.365-.55l-11.563-4.742a.567.567 0 0 0-.43 0l-11.565 4.741a.594.594 0 0 0-.362.551v14.225c-.001.242.144.461.362.551l11.565 4.741a.557.557 0 0 0 .43 0l11.563-4.74a.593.593 0 0 0 .365-.552v-9.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M15.324 6.117c5.236-2.64 9.098-3.959 11.587-3.959 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.119-9.33 4.679-11.958 4.679s-6.366-1.56-11.216-4.68V6.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M37.763 12.19v7.618l-10.408 4.267V11.127l10.408-4.268v5.33zM26.198 24.075L15.79 19.808V6.858l10.41 4.269v12.948zm.578-22.195l10.008 4.103-10.008 4.088-9.975-4.088 9.975-4.103zm12.143 9.305V5.984a.59.59 0 0 0-.364-.551L26.99.69a.567.567 0 0 0-.43 0L14.996 5.433a.594.594 0 0 0-.362.551v14.224c0 .242.144.462.362.552L26.561 25.5a.557.557 0 0 0 .43 0l11.564-4.741a.593.593 0 0 0 .364-.552v-9.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M26.509 25.194c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.12-9.33 4.679-11.958 4.679s-6.366-1.56-11.216-4.68v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M48.948 31.266v7.618L38.54 43.152v-12.95l10.408-4.267v5.331zM37.383 43.152l-10.409-4.268V25.935l10.41 4.268v12.949zm.578-22.196l10.008 4.103-10.008 4.088-9.975-4.088 9.975-4.103zm12.143 9.305v-5.2a.59.59 0 0 0-.364-.552l-11.564-4.741a.567.567 0 0 0-.43 0l-11.565 4.74a.594.594 0 0 0-.362.552v14.225c0 .241.144.46.362.55l11.565 4.742a.557.557 0 0 0 .43 0l11.564-4.741a.593.593 0 0 0 .364-.551V30.26z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.71 27.284l10.746-4.488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.509 10.713c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.12-9.33 4.68-11.958 4.68s-6.366-1.56-11.216-4.68v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M48.948 16.786v7.618L38.54 28.67V15.722l10.408-4.267v5.33zM37.383 28.67l-10.409-4.267v-12.95l10.41 4.268v12.95zm.578-22.195l10.008 4.103-10.008 4.088-9.975-4.088 9.975-4.103zm12.143 9.305V10.58a.59.59 0 0 0-.364-.551L38.176 5.287a.567.567 0 0 0-.43 0L26.181 10.03a.594.594 0 0 0-.362.55v14.225c0 .242.144.461.362.551l11.565 4.742a.557.557 0 0 0 .43 0l11.564-4.742a.593.593 0 0 0 .364-.55V15.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M4.139 25.194c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.12-9.33 4.679-11.958 4.679s-6.366-1.56-11.216-4.68v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M26.578 31.266v7.618L16.17 43.152v-12.95l10.408-4.267v5.331zM15.013 43.152L4.604 38.884V25.935l10.41 4.268v12.949zm.578-22.196L25.6 25.059 15.59 29.147l-9.975-4.088 9.975-4.103zm12.143 9.305v-5.2a.59.59 0 0 0-.364-.552l-11.564-4.741a.567.567 0 0 0-.43 0l-11.564 4.74a.594.594 0 0 0-.363.552v14.225c0 .241.144.46.363.55l11.564 4.742a.557.557 0 0 0 .43 0l11.564-4.741a.593.593 0 0 0 .364-.551V30.26z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.34 27.284l10.746-4.488"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M4.139 10.713c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.12-9.33 4.68-11.958 4.68s-6.366-1.56-11.216-4.68v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M26.578 16.786v7.618L16.17 28.67V15.722l10.408-4.267v5.33zM15.013 28.67L4.604 24.404v-12.95l10.41 4.268v12.95zm.578-22.195L25.6 10.579 15.59 14.667l-9.975-4.088 9.975-4.103zm12.143 9.305V10.58a.59.59 0 0 0-.364-.551L15.806 5.287a.567.567 0 0 0-.43 0L3.812 10.03a.594.594 0 0 0-.363.55v14.225c0 .242.144.461.363.551l11.564 4.742a.557.557 0 0 0 .43 0l11.564-4.742a.593.593 0 0 0 .364-.55V15.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M15.324 29.79c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.119-9.33 4.679-11.958 4.679s-6.366-1.56-11.216-4.68V29.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M37.763 35.862v7.618l-10.408 4.267V34.8l10.408-4.268v5.33zM26.198 47.747L15.79 43.48V30.53L26.2 34.8v12.948zm.578-22.195l10.008 4.103-10.008 4.088-9.975-4.088 9.975-4.103zm12.143 9.305v-5.201a.59.59 0 0 0-.364-.551L26.99 24.363a.567.567 0 0 0-.43 0l-11.565 4.742a.594.594 0 0 0-.362.55V43.88c0 .242.144.462.362.552l11.565 4.74a.557.557 0 0 0 .43 0l11.564-4.74a.593.593 0 0 0 .364-.552v-9.023z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.524 31.88l10.747-4.488"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M15.324 15.309c5.236-2.64 9.098-3.96 11.587-3.96 2.488 0 6.14 1.32 10.957 3.96l.63 14.21c-5.345 3.12-9.33 4.68-11.958 4.68s-6.366-1.56-11.216-4.68V15.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F536E",
    stroke: "#3F536E",
    d: "M37.763 21.382v7.617l-10.408 4.268V20.318l10.408-4.268v5.332zM26.198 33.267L15.79 28.999V16.05l10.41 4.268v12.949zm.578-22.196l10.008 4.103-10.008 4.088-9.975-4.088 9.975-4.103zm12.143 9.306v-5.201a.59.59 0 0 0-.364-.552L26.99 9.883a.567.567 0 0 0-.43 0l-11.565 4.741a.594.594 0 0 0-.362.552V29.4c0 .242.144.461.362.551l11.565 4.742a.557.557 0 0 0 .43 0l11.564-4.742a.593.593 0 0 0 .364-.551v-9.023z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0093EE",
    stroke: "#0093EE",
    strokeWidth: 3,
    d: "M19.956 36.598l-10.903-4.36v-8.203l10.903 4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCAF17",
    stroke: "#FFF",
    d: "M11.387 27.677l5.947 2.478M11.387 29.164l5.947 2.478M11.387 30.65l5.947 2.479"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0093EE",
    stroke: "#0093EE",
    strokeWidth: 3,
    d: "M34.935 10.173l-8.773 4.077-8.013-3.646 8.773-4.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCAF17",
    stroke: "#FFF",
    d: "M25.214 12.324l5.585-2.543M23.814 11.516l5.585-2.543M22.043 10.878l5.585-2.543"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0093EE",
    stroke: "#0093EE",
    strokeWidth: 3,
    d: "M33.453 35.688l10.903-4.36v-8.203l-10.903 4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCAF17",
    stroke: "#FFF",
    d: "M42.023 26.767l-5.948 2.478M42.023 28.254l-5.948 2.478M42.023 29.74l-5.948 2.479"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#CBAB87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M26.723 51.955L51.19 41.922M26.723 56.341L51.19 46.308"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabelingPallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/labeling_pallet.8ee3ed68.svg";
export { ForwardRef as ReactComponent };